// extracted by mini-css-extract-plugin
export default {"layout":"app_layout__BCZEk","content":"app_content__u0iVT","contentFullWidth":"app_contentFullWidth__+lxTc"};